<div class="tw-text-center tw-font-extrabold tw-text-xl md:tw-text-3xl tw-pb-6">Customer Testimonials</div>

<div id="carouselExampleIndicators" class="container carousel carousel-fade" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <div data-bs-target="#carouselExampleIndicators" *ngFor="let slide of customerTestimonial; let i = index"
      [class.active]="i===currentSlide" [attr.data-slide-to]="i" (click)="nextSlide(i)"></div>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div class="tw-flex tw-gap-2 tw-flex-col md:tw-flex-row tw-h-[30rem] md:tw-h-[15rem]">
        <div class="tw-basis-2/6 tw-m-auto">
          <img class="tw-w-[15rem] tw-float-right tw-rounded-lg"
            src="/assets/images/corporate/testimonial-photos/{{customerTestimonial[currentSlide].avatar}}" alt="{{customerTestimonial[currentSlide].name}}">
        </div>
        <div class="tw-basis-4/6 tw-bg-yellow/[0.1] tw-rounded-lg tw-text-xs md:tw-text-sm tw-py-6 md:tw-py-12 tw-px-12 md:tw-pr-24">
          <p>{{customerTestimonial[currentSlide].story}}</p>
          <p class="tw-font-bold tw-pt-6">{{customerTestimonial[currentSlide].name}}</p>
          <p><small class="tw-font-bold text-muted">{{customerTestimonial[currentSlide].designation}}</small>
          </p>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev"
    (click)="nextSlide(-1)">
    <span><fa-icon [icon]="faAngleRight" class="tw-text-yellow fa-2xl"></fa-icon></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next"
    (click)="nextSlide(1)">
    <span><fa-icon [icon]="faAngleLeft" class="tw-text-yellow fa-2xl"></fa-icon></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>